import { render, staticRenderFns } from "./DateAsWeekday.vue?vue&type=template&id=e198802c&scoped=true"
import script from "./DateAsWeekday.vue?vue&type=script&lang=js"
export * from "./DateAsWeekday.vue?vue&type=script&lang=js"
import style0 from "./DateAsWeekday.vue?vue&type=style&index=0&id=e198802c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e198802c",
  null
  
)

export default component.exports